import { configureStore } from "@reduxjs/toolkit";
import dataReducer from "./slices/data"; // or your combined reducers
import partnersReducer from "./slices/partnersSlice"; // Add your slice here
export const store = configureStore({
  reducer: {
    data: dataReducer,
    partners: partnersReducer, // Add your slice here
  },
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
